import {Button, Form, Input, Modal} from "antd";
import {useNavigate} from "react-router";
import {useAppDispatch, useAppSelector} from "../app/hooks";
import {clearAddPatientError, initAddPatientState} from "../features/patient/addPatientSlice";
import {useTranslate} from "../i18n";
import {getErrorMessage} from "../utils/getErrorMessage";
import {PatientResponseDto} from "../api/client-axios";
import {getPatientByCode, initAddPatientByCodeState, setActivationCode} from "../features/patient/addPatientByCode";
import {PageHeader} from "./PageHeader";
import {TableSkeleton} from "./TableSkeleton";

export const AddPatientByCode = (props: { onConfirm: (patient: PatientResponseDto) => void }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const t = useTranslate();
    const status = useAppSelector((state) => state.addPatientByCode.status);
    const error = useAppSelector((state) => state.addPatientByCode.error);
    const patient = useAppSelector((state) => state.addPatientByCode.patient);
    const code = useAppSelector((state) => state.addPatientByCode.activationCode);


    const onSend = () => {
        dispatch(getPatientByCode(code));
    }

    const onChangeCode = (value: string) => {
        dispatch(setActivationCode(value));
    }

    const isModalVisible = status == "error" || status == "auth-error";

    const handleAuthOk = () => {
        dispatch(clearAddPatientError())
        navigate("/")
    }

    const handleErrorOk = () => {
        dispatch(clearAddPatientError())
    }

    const handleCancel = () => {
        dispatch(clearAddPatientError())
    }


    if (status === "loading") {
        return <>
            <PageHeader eyebrow={t("nav.patients")} title={t("addPatient.pageTitle")}/>
            <TableSkeleton rows={3}/>
        </>
    }

    if (status === "auth-error") {
        return <Modal
            title={t("auth.failed.title")}
            visible={isModalVisible}
            onOk={handleAuthOk}
            okText={t("common.signIn")}
            onCancel={handleCancel}
            cancelButtonProps={{hidden: true}}
        >
            <p>{t("auth.failed.body")}</p>
        </Modal>
    }


    if (status === "error") {
        const errorMessage = getErrorMessage(error, t);
        return <Modal
            title={errorMessage.title}
            visible={isModalVisible}
            onOk={handleErrorOk}
            onCancel={handleCancel}
            cancelButtonProps={{hidden: true}}
        >
            <p>{errorMessage.details}</p>
        </Modal>
    }

    if (patient?.userAccount?.id != null) {
        props.onConfirm(patient);
        dispatch(initAddPatientByCodeState());
    }

    const onCancel = () => {
        dispatch(initAddPatientState());
        navigate(-1);
    }

    return (
        <div className="form-panel">
            <div className="form-panel__head">
                <span className="eyebrow">{t("addPatient.eyebrow")}</span>
                <span className="form-panel__title">{t("addPatient.code.title")}</span>
                <span className="form-panel__hint">{t("addPatient.code.hint")}</span>
            </div>
            <Form
                className='person-form'
                name="add-patient"
                layout="vertical"
                autoComplete="off"
            >
                <Form.Item
                    initialValue={code}
                    name="activationCode"
                    label={t("addPatient.code.label")}
                    rules={[{required: true, message: t("person.rule.code")}]}
                >
                    <Input type="tel" placeholder={t("addPatient.code.placeholder")} value={code}
                           onChange={(e) => onChangeCode(e.target.value)}/>
                </Form.Item>
            </Form>
            <div className="form-panel__actions">
                <Button onClick={onCancel}>{t("common.cancel")}</Button>
                <Button type='primary' onClick={onSend}>{t("common.continue")}</Button>
            </div>
        </div>);
}
